(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-slider"] && !Shopify.designMode) return;
  try {
    
var initImageWithTextSlider = function(root) {
if (!root) return;
if (typeof jQuery === 'undefined') return;

var $root = jQuery(root);
var $slider = $root.find('.js-image-with-text-slider');

if (!$slider.length || !$slider.children().length) return;

if ($slider.hasClass('owl-loaded')) {
$slider.trigger('destroy.owl.carousel');
$slider.removeClass('owl-loaded owl-hidden');
$slider.find('.owl-stage-outer').children().unwrap();
}

$slider.owlCarousel({
items: 1,
loop: true,
nav: false,
dots: false,
slideBy: 1,
margin: 0,
mouseDrag: true,
touchDrag: true,
smartSpeed: 500
});

var $prev = $root.find('.image-text-prev');
var $next = $root.find('.image-text-next');

if ($prev.length) {
$prev.off('.imageText').on('click.imageText', function(e) {
e.preventDefault();
$slider.trigger('prev.owl.carousel');
});
}

if ($next.length) {
$next.off('.imageText').on('click.imageText', function(e) {
e.preventDefault();
$slider.trigger('next.owl.carousel');
});
}
};

document.addEventListener('DOMContentLoaded', function() {
var sections = document.querySelectorAll('.section-image-with-text-slider');
sections.forEach(function(section) {
initImageWithTextSlider(section);
});
});

document.addEventListener('shopify:section:load', function(e) {
initImageWithTextSlider(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features"] && !Shopify.designMode) return;
  try {
    
function throttle(fn, wait) {
  if (wait === void 0) wait = 300;
  var timeoutId = -1;
  var tick = false;

  return function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn();
      tick = true;
      setTimeout(function() {
        tick = false;
      }, wait);
    }
  };
}

function enableKeyFeaturesDesktop(sectionEl) {
  if (sectionEl._kfDesktopEnabled) return;

  var images = sectionEl.querySelectorAll('.scrolling-image-list__image');
  if (!images.length || images.length === 1) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  var contentColumn = sectionEl.querySelector('.scrolling-image-list__content-column');
  var featureText = contentColumn ? contentColumn.querySelector('.feature-text-paired') : null;
  if (!contentColumn || !featureText) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  function distanceFromViewportMiddle(el) {
    var viewportMidY = window.scrollY + window.innerHeight / 2;
    var rect = el.getBoundingClientRect();
    var imageMidY = window.scrollY + rect.top + rect.height / 2;
    return Math.abs(viewportMidY - imageMidY);
  }

  function handleScroll() {
    var closestIndex = 1;
    var closestDistance = Number.MAX_VALUE;

    images.forEach(function(el, index) {
      var distance = distanceFromViewportMiddle(el);
      if (distance < closestDistance) {
        closestIndex = index + 1;
        closestDistance = distance;
      }
    });

    sectionEl.setAttribute('data-current-index', String(closestIndex));
  }

  function updatePositioning() {
    var containerBcr = contentColumn.getBoundingClientRect();
    var containerOffset = containerBcr.top + window.scrollY;
    var contentHeight = featureText.getBoundingClientRect().height;

    var firstRect = images[0].getBoundingClientRect();
    var topImageMid = firstRect.top + window.scrollY + firstRect.height / 2;
    var lastRect = images[images.length - 1].getBoundingClientRect();
    var botImageMid = lastRect.top + window.scrollY + lastRect.height / 2;

    var windowMid = window.scrollY + window.innerHeight / 2;

    if (windowMid < topImageMid) {
      sectionEl.style.setProperty(
        '--scrolling-image-list-content-offset-y',
        (topImageMid - containerOffset - contentHeight / 2) + 'px'
      );
      sectionEl.style.removeProperty('--scrolling-image-list-content-position');
      sectionEl.style.removeProperty('--scrolling-image-list-content-offset-x');
      sectionEl.style.removeProperty('--scrolling-image-list-content-width');
    } else if (windowMid > botImageMid) {
      sectionEl.style.setProperty(
        '--scrolling-image-list-content-offset-y',
        (botImageMid - containerOffset - contentHeight / 2) + 'px'
      );
      sectionEl.style.removeProperty('--scrolling-image-list-content-position');
      sectionEl.style.removeProperty('--scrolling-image-list-content-offset-x');
      sectionEl.style.removeProperty('--scrolling-image-list-content-width');
    } else {
      sectionEl.style.setProperty('--scrolling-image-list-content-position', 'fixed');
      sectionEl.style.setProperty(
        '--scrolling-image-list-content-offset-y',
        (window.innerHeight / 2 - contentHeight / 2) + 'px'
      );
      sectionEl.style.setProperty('--scrolling-image-list-content-offset-x', containerBcr.left + 'px');
      sectionEl.style.setProperty('--scrolling-image-list-content-width', containerBcr.width + 'px');
    }
  }

  function onScroll() {
    handleScroll();
    updatePositioning();
  }

  var throttledHandleScroll = throttle(onScroll, 100);
  sectionEl._kfScrollHandler = throttledHandleScroll;

  window.addEventListener('scroll', throttledHandleScroll);
  window.addEventListener('resize', throttledHandleScroll);

  images.forEach(function(el) {
    el.addEventListener('click', function() {
      var index = parseInt(el.getAttribute('data-index'), 10);
      var img = images[index - 1];
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var targetTop = window.scrollY + rect.top - (window.innerHeight - rect.height) / 2;
      window.scrollTo({
        top: targetTop,
        left: 0,
        behavior: 'smooth'
      });
    });
  });

  throttledHandleScroll();
  sectionEl.setAttribute('loaded', '');
  sectionEl._kfDesktopEnabled = true;
}

function disableKeyFeaturesDesktop(sectionEl) {
  if (!sectionEl._kfDesktopEnabled) return;

  if (sectionEl._kfScrollHandler) {
    window.removeEventListener('scroll', sectionEl._kfScrollHandler);
    window.removeEventListener('resize', sectionEl._kfScrollHandler);
    sectionEl._kfScrollHandler = null;
  }

  sectionEl.style.removeProperty('--scrolling-image-list-content-offset-y');
  sectionEl.style.removeProperty('--scrolling-image-list-content-position');
  sectionEl.style.removeProperty('--scrolling-image-list-content-offset-x');
  sectionEl.style.removeProperty('--scrolling-image-list-content-width');

  sectionEl._kfDesktopEnabled = false;
}

function enableKeyFeaturesMobile(sectionEl) {
  if (sectionEl._kfMobileEnabled) return;

  if (!window.jQuery || !jQuery.fn.owlCarousel) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  var carousel = sectionEl.querySelector('carousel-slider');
  if (!carousel) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  var grid = carousel.querySelector('.slider__grid');
  if (!grid) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  var slides = grid.querySelectorAll('.slider__item');
  if (!slides.length) {
    sectionEl.setAttribute('loaded', '');
    return;
  }

  var $grid = jQuery(grid);
  if ($grid.data('owl.carousel')) {
    sectionEl._kfOwl = $grid;
    sectionEl._kfMobileEnabled = true;
    return;
  }

  $grid.addClass('owl-carousel');

  $grid.owlCarousel({
    items: 1,
    loop: false,
    nav: false,
    dots: true,
    dotsContainer: jQuery(sectionEl).find('.scrolling-image-list-dots'),
    touchDrag: true,
    mouseDrag: true,
    smartSpeed: 300
  });

  $grid.on('changed.owl.carousel', function(e) {
    if (!e || !e.item) return;
    var idx = e.item.index;
    var count = e.item.count || slides.length;
    if (idx < 0) idx = 0;
    if (idx > count - 1) idx = count - 1;
    sectionEl.setAttribute('data-current-index', String(idx + 1));
  });

  if (!window._kfScrollbarHiddenStyle) {
    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.scrolling-image-list carousel-slider .slider::-webkit-scrollbar{display:none;}' +
      '.scrolling-image-list carousel-slider .slider{scrollbar-width:none;-ms-overflow-style:none;}';
    document.head.appendChild(styleEl);
    window._kfScrollbarHiddenStyle = true;
  }

  sectionEl.setAttribute('data-current-index', '1');
  sectionEl.setAttribute('loaded', '');
  sectionEl._kfOwl = $grid;
  sectionEl._kfMobileEnabled = true;
}

function disableKeyFeaturesMobile(sectionEl) {
  if (!sectionEl._kfMobileEnabled) return;
  if (!sectionEl._kfOwl) {
    sectionEl._kfMobileEnabled = false;
    return;
  }

  var $grid = sectionEl._kfOwl;
  if ($grid.data('owl.carousel')) {
    $grid.trigger('destroy.owl.carousel');
  }
  $grid.removeClass('owl-carousel');
  $grid.off('changed.owl.carousel');

  sectionEl._kfOwl = null;
  sectionEl._kfMobileEnabled = false;
}

function initKeyFeaturesSection(sectionEl) {
  if (!sectionEl) return;
  if (sectionEl._kfInitialised) return;
  sectionEl._kfInitialised = true;

  var mq = window.matchMedia('(min-width: 990px)');

  function setMode(matches) {
    if (matches) {
      disableKeyFeaturesMobile(sectionEl);
      enableKeyFeaturesDesktop(sectionEl);
    } else {
      disableKeyFeaturesDesktop(sectionEl);
      enableKeyFeaturesMobile(sectionEl);
    }
  }

  setMode(mq.matches);

  function mqHandler(e) {
    setMode(e.matches);
  }

  sectionEl._kfMq = mq;
  sectionEl._kfMqHandler = mqHandler;

  if (mq.addEventListener) {
    mq.addEventListener('change', mqHandler);
  } else if (mq.addListener) {
    mq.addListener(mqHandler);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.scrolling-image-list').forEach(function(sectionEl) {
    initKeyFeaturesSection(sectionEl);
  });
});

document.addEventListener('shopify:section:load', function(event) {
  var selector = '.scrolling-image-list[data-section-id="' + event.detail.sectionId + '"]';
  var sectionEl = document.querySelector(selector);
  if (sectionEl) {
    initKeyFeaturesSection(sectionEl);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var initProductRecommendationsSlider = function(root) {
  if (!root) return;
  if (typeof jQuery === 'undefined') return;

  var $root = jQuery(root);
  var $slider = $root.find('.js-product-recs-slider');

  if (!$slider.length || !$slider.children().length) return;

  var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1024;
  var stagePaddingMobile = Math.round(viewportWidth * 0.08);
  var stagePaddingTablet = Math.round(viewportWidth * 0.10);
  var stagePaddingDesktop = Math.round(viewportWidth * 0.15);

  if ($slider.hasClass('owl-loaded')) {
    $slider.trigger('destroy.owl.carousel');
    $slider.removeClass('owl-loaded owl-hidden');
    $slider.find('.owl-stage-outer').children().unwrap();
  }

  $slider.owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    slideBy: 1,
    margin: 24,
    mouseDrag: true,
    touchDrag: true,
    items: 3,
    responsive: {
      0: {
        items: 1,
        stagePadding: stagePaddingMobile
      },
      600: {
        items: 2,
        stagePadding: stagePaddingTablet
      },
      900: {
        items: 3,
        stagePadding: stagePaddingDesktop
      }
    }
  });

  var $prev = $root.find('.product-recs-prev');
  var $next = $root.find('.product-recs-next');

  if ($prev.length) {
    $prev.off('.productRecs').on('click.productRecs', function(e) {
      e.preventDefault();
      $slider.trigger('prev.owl.carousel');
    });
  }

  if ($next.length) {
    $next.off('.productRecs').on('click.productRecs', function(e) {
      e.preventDefault();
      $slider.trigger('next.owl.carousel');
    });
  }
};

var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection === null) return;

  var request = new XMLHttpRequest();
  request.open('GET', productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement('div');
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
      if (window.theme && theme.ProductBlockManager && typeof theme.ProductBlockManager.loadImages === 'function') {
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
      }
      if (window.theme && typeof theme.initAnimateOnScroll === 'function') {
        theme.initAnimateOnScroll();
      }
      initProductRecommendationsSlider(productRecommendationsSection);
    }
  };
  request.send();
};

document.addEventListener('shopify:section:load', function(event) {
  var selector = '[data-section-id="' + event.detail.sectionId + '"].product-recommendations';
  if (document.querySelector(selector)) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.product-recommendations');
  if (section) initProductRecommendationsSlider(section);
});

window.addEventListener('resize', function() {
  var section = document.querySelector('.product-recommendations');
  if (section) initProductRecommendationsSlider(section);
});

  } catch(e) { console.error(e); }
})();
})();
